module.exports = __webpack_public_path__ + "static/favicon-8ca344c7f1dfab32b774ac66d7b46da5.ico";